<template>
  <div class="py-5 border-t dark:border-gray-800 mt-5 text-zinc-700 dark:text-zinc-300">
    <div class="px-6 container md:max-w-2xl lg:max-w-4xl xl:max-w-5xl 2xl:max-w-7xl mx-auto">
      <div class="text-center p-2">© Copyright 2025 • Baêta Advocacia</div>
    </div>
  </div>
</template>
<script setup lang="ts"></script>
